import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import AppShare from './AppShare';

loadDOMComponent({
	selector: 'react-app-share',
	callback: ({ container }) => {
		ReactDOM.render(
			<AppContextProvider>
				<AppShare />
			</AppContextProvider>,
			container,
		);
	},
});
